import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 border mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border p-1" }, [
    /*#__PURE__*/_createElementVNode("label", {
      for: "A",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "A",
        name: "exterior-radio",
        value: "A"
      }),
      /*#__PURE__*/_createTextVNode(" 【A】キズ ")
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "B",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "B",
        name: "exterior-radio",
        value: "B"
      }),
      /*#__PURE__*/_createTextVNode(" 【B】傷を伴うヘコミ ")
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "C",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "C",
        name: "exterior-radio",
        value: "C"
      }),
      /*#__PURE__*/_createTextVNode(" 【C】腐食 ")
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "G",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "G",
        name: "exterior-radio",
        value: "G"
      }),
      /*#__PURE__*/_createTextVNode(" 【G】ガラス点傷 ")
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "P",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "P",
        name: "exterior-radio",
        value: "P"
      }),
      /*#__PURE__*/_createTextVNode(" 【P】要塗装 ")
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "U",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "U",
        name: "exterior-radio",
        value: "U"
      }),
      /*#__PURE__*/_createTextVNode(" 【U】ヘコミ ")
    ]),
    /*#__PURE__*/_createElementVNode("label", {
      for: "N",
      class: "text-nowrap me-2"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "radio",
        id: "N",
        name: "exterior-radio",
        value: "",
        checked: ""
      }),
      /*#__PURE__*/_createTextVNode(" 【N】無し ")
    ])
  ])
], -1)
const _hoisted_3 = {
  class: "w-100",
  style: {"background-image":"url(/images/check_01.png)","background-size":"100% 100%","background-repeat":"no-repeat"}
}
const _hoisted_4 = ["id", "data-row", "data-col", "onMousedown", "onTouchstart"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " 閉じる ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BsModal = _resolveComponent("BsModal")!

  return (_openBlock(), _createBlock(_component_BsModal, {
    ref: "exteriorCheckModalRef",
    class: "fade"
  }, {
    header: _withCtx(() => []),
    footer: _withCtx(() => [
      _hoisted_5,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setExteriorData()), ["prevent"])),
        onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setExteriorData()), ["prevent"]))
      }, " 保存 ", 32)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exteriorCheckRow, (m) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row d-flex flex-nowrap px-3",
              key: m
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exteriorCheckCol, (n) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: n,
                  id: 'exterior_modal_' + m + '_' + n,
                  class: "col d-flex align-items-center justify-content-center exterior_cell border",
                  style: {"height":"40px","font-size":"150%"},
                  "data-row": m,
                  "data-col": n,
                  onMousedown: _withModifiers(($event: any) => (_ctx.setExteriorCheck(m, n)), ["prevent"]),
                  onTouchstart: _withModifiers(($event: any) => (_ctx.setExteriorCheck(m, n)), ["prevent"])
                }, null, 40, _hoisted_4))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 512))
}